import { FunctionComponent, PropsWithChildren } from "react";

import { DialogFooter, Spinner, Stack, useTheme } from "@bps/fluent-ui";

interface ServerMigrationFooterProps {
  loadingText?: string;
}

export const ServerMigrationFooter: FunctionComponent<PropsWithChildren<
  ServerMigrationFooterProps
>> = ({ loadingText, children }) => {
  const theme = useTheme();

  return (
    <DialogFooter>
      <Stack
        horizontal
        horizontalAlign="end"
        verticalAlign="center"
        tokens={{ childrenGap: theme.spacing.s1 }}
      >
        {loadingText && <Spinner label={loadingText} labelPosition="right" />}
        {children}
      </Stack>
    </DialogFooter>
  );
};
